export default "__VITE_ASSET__02cb71d3__"